<h4 class="text-xl font-semibold px-4 sm:px-0 mt-1 pr-3 mb-2">
  {{ '#WORK_NOTE.DIALOGS.CREATE.TITLE' | translate }}
</h4>

<form
  [formGroup]="form"
  (ngSubmit)="submit()"
  class="flex flex-col gap-4 w-full"
  >
  <div class="flex flex-col gap-4 justify-center px-4 sm:px-0">
    <!-- <input
    class="soft-input"
    type="number"
    name="belegnummerau"
    formControlName="belegnummerau"
    placeholder="Belegnummer"
    /> -->
    <soft-date-input formControlName="belegdatum"></soft-date-input>
  </div>
  <div class="flex c items-center justify-end w-full sm:gap-4 flex-nowrap">
    <button
      type="button"
      class="soft-button secondary adaptive-button-layout h-12 sm:w-auto sm:h-auto"
      (click)="closeDialog()"
      >
      Abbrechen
    </button>
    <button
      type="submit"
      class="soft-button primary h-12 adaptive-button-layout sm:w-auto sm:h-auto sm:min-w-[2.75rem]"
      [disabled]="form.invalid"
      >
      @if (loading$ | async) {
        <soft-loading-spinner class="spin"></soft-loading-spinner>
      } @else {
        Erstellen
      }
    </button>
  </div>
</form>
